import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { BoltDirectivesModule } from '@nationwide-bolt/ng-directives';
import { ClaimsTrackerGuard } from 'app/route_guards/claims-tracker.guard';
import { AccessGuard } from 'app/route_guards/router-access.guard';
import { NwBoxComponentModule } from 'app/shared/components/nw-ui/nw-box/nw-box.module';
import { ClaimDetailsComponent } from './claim-details/claim-details.component';
import { ClaimTrackerProperty } from './claim-tracker-property.component';
import { ClaimUpdatesComponent } from './claim-updates/claim-updates.component';
import { ContractorsComponent } from './contractors/contractors.component';
import { PhoneFormatPipe } from './contractors/phone-format.pipe';
import { CoveragesComponent } from './coverages/coverages.component';
import { DocumentUploadComponent } from './documents/document-upload/document-upload.component';
import { DocumentsComponent } from './documents/documents.component';
import { PaymentPreferencesComponent } from './payment-preferences/payment-preferences.component';
import { PaymentsComponent } from './payments/payments.component';
import { SupportComponent } from './support/support.component';
import { TellUsMoreModalComponent } from './tell-us-more-modal/tell-us-more-modal.component';
import { TimelineComponent } from './timeline/timeline.component';

const routes: Routes = [
    {
        path: '',
        component: ClaimTrackerProperty,
        canActivate: [ClaimsTrackerGuard, AccessGuard],
        data: { title: 'Track Your Claim' }
    },
    {
        path: 'updates',
        component: ClaimDetailsComponent,
        canActivate: [AccessGuard],
        data: { title: 'Updates' }
    },
    {
        path: 'documents',
        component: ClaimDetailsComponent,
        canActivate: [AccessGuard],
        data: { title: 'Documents' }
    },
    {
        path: 'coverages',
        component: ClaimDetailsComponent,
        canActivate: [AccessGuard],
        data: { title: 'Coverages' }
    },
    {
        path: 'contractors',
        component: ClaimDetailsComponent,
        canActivate: [AccessGuard],
        data: { title: 'Contractors' }
    },
    {
        path: 'payments',
        component: ClaimDetailsComponent,
        canActivate: [AccessGuard],
        data: { title: 'Payments' }
    },
    {
        path: 'support',
        component: ClaimDetailsComponent,
        canActivate: [AccessGuard],
        data: { title: 'Support' }
    }

];

@NgModule({
    declarations: [ClaimTrackerProperty, ClaimDetailsComponent, ClaimUpdatesComponent, PaymentsComponent, ContractorsComponent, PhoneFormatPipe, CoveragesComponent, SupportComponent, DocumentsComponent, DocumentUploadComponent, TimelineComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        FormsModule,
        TellUsMoreModalComponent,
        PaymentPreferencesComponent,
        RouterModule.forChild(routes),
        BoltDirectivesModule,
        NwBoxComponentModule
    ]
})
export class ClaimTrackerPropertyModule {}
